import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// CS 17.1 + 17.4 — Suppress the harmless browser-level "ResizeObserver loop" warning.
// Radix UI's Select (used by shadcn/ui) triggers this notice on rapid layout
// shifts during open/close. The webpack-dev-server overlay catches it as a fatal
// error because the ErrorEvent carries a `message` (browsers report RO warnings
// via window error events even though there's no real exception).
//
// Primary fix is in craco.config.js (devServer.client.overlay.runtimeErrors filter).
// These window-level capture-phase listeners are defense-in-depth in case some
// other path (3rd-party libs, future build tools) reports the same warning.
const RESIZE_OBSERVER_ERROR_MSG = "ResizeObserver loop";
const isResizeObserverError = (msg) => {
  if (!msg) return false;
  const str = typeof msg === "string" ? msg : msg.toString();
  return str.includes(RESIZE_OBSERVER_ERROR_MSG);
};

window.addEventListener(
  "error",
  (event) => {
    if (isResizeObserverError(event.message) || isResizeObserverError(event.error && event.error.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
    return undefined;
  },
  true, // capture phase — ensure we run before webpack-dev-server overlay listener
);

window.addEventListener(
  "unhandledrejection",
  (event) => {
    const reason = event.reason;
    const msg = reason && (reason.message || String(reason));
    if (isResizeObserverError(msg)) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
    return undefined;
  },
  true,
);

// Some libraries route warnings through console.error rather than throwing.
// Patch console.error so any RO warning reported that way is also dropped.
const originalConsoleError = console.error.bind(console);
console.error = (...args) => {
  const first = args[0];
  const text = typeof first === "string" ? first : first && first.message;
  if (isResizeObserverError(text)) return;
  originalConsoleError(...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
